export default __webpack_public_path__ + "static/media/edit-icon-purple.39724d38.svg";